export default __webpack_public_path__ + "static/media/icon-edit.b5259e88.svg";